import { render, staticRenderFns } from "./drawer-item.vue?vue&type=template&id=57f7c9a8&scoped=true&"
import script from "./drawer-item.vue?vue&type=script&lang=js&"
export * from "./drawer-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7c9a8",
  null
  
)

export default component.exports